import React, { useEffect, useState } from 'react'
import ImportOutgoing from './ImportOutgoing';
import MultiEditOutgoing from './MultiEditOutgoing';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate } from '../../../../Components/Utils/Input';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import InvoiceLayout from '../InvoiceLayout';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import { useLocation, useParams } from 'react-router-dom';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import * as yup from 'yup';
import { GetAccess, GetNotUseRole } from '../../../../Components/Utils/roles';
import MobileOutgoingIndex from '../../../Mobile/Invoice/Outgoing/MobileOutgoingIndex';
import CloseIcon from '../../../../Components/Icons/Close';
import axiosInstance from '../../../../Services/axiosCommon';



function InvoiceOutgoingIndex() {
    const {officeId,projecTId} =useParams();

    const location = useLocation();
   const state = location.state;

    const currentPage= location.state?.currentPage
    const searchQuery= location.state?.searchQuery
    const [page, setPage] = useState(currentPage||1)
    const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
    const [filter, setFilter] = useState(false);
    const [showExport, setShowExport] = useState(false);

      const [showFilterDialog, setShowFilterDialog] = useState(false);
      const {value:ModeOfPayment} = useFetchMDIndex(`/dropdown/dropdown-details/`,'Mode_of_Payment_Outgoing',[showFilterDialog, showExport],
    () => showFilterDialog || showExport)
      const {value:Division} = useFetchMDIndex(`/dropdown/dropdown-details/`,'Division_invoices',[showFilterDialog, showExport],
    () => showFilterDialog || showExport)
      const {value:Status} = useFetchMDIndex(`/dropdown/dropdown-details/`,'Status_Outgoing',[showFilterDialog, showExport],
    () => showFilterDialog || showExport)
     
      const [filterProps, setFilterProps] = useState({
        division:"",
      status:"",
      modeOfPayment:"",
      fromDate:"",
      toDate:"",
      fromDueDate:"",
      toDueDate:"",
  
      });
      const [params, setParams] = useState({
        page: page,
        per_page: pageCount,
        search:searchQuery||"",
  
        division:"",
        status:state?.status? state.status :"",
        modeOfPayment:"",
        fromDate:"",
  toDate:"",
  fromDueDate:"",
  toDueDate:""
  
  
      });
    
      const clearFilter = ()=> {
        setParams({...params, division:"",
        status:"",
        modeOfPayment:"",
        fromDate:"",
  toDate:"",
  fromDueDate:"",
  toDueDate:""})
        formik.values.status=""
        formik.values.division=""
        formik.values.modeOfPayment=""
        formik.values.fromDate=""
        formik.values.toDate=""
        formik.values.fromDueDate=""
        formik.values.toDueDate=""
  
          setFilter(false)
      }
    
      const formik = useFormik({
        enableReinitialize: true,
        initialValues: filterProps,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: yup.object({
          // email: yup.string().required('Email is required!'),
        }),
        onSubmit: async (value, { resetForm }) => {
          console.log("ffff",value);
          setParams({...params,modeOfPayment:value.modeOfPayment, division:value.division,status:value.status,fromDate:value.fromDate,toDate:value.toDate,fromDueDate:value.fromDueDate,toDueDate:value.toDueDate})
          closeFilterDialog();
          setFilter(true)
          setFilterProps({
            division:"",
      status:"",
      modeOfPayment:"",
      fromDate:"",
      toDate:"",
      fromDueDate:"",
      toDueDate:""
  
          });
        }
      })
  
      const [screenSize, setScreenSize] = useState({
          width: window.innerWidth,
        });
      
        useEffect(() => {
            const handleResize = () => {
              setScreenSize({
                width: window.innerWidth,
              });
            };
        
            window.addEventListener("resize", handleResize);
        
            return () => {
              window.removeEventListener("resize", handleResize);
            };
          }, []);
    
      const { data, totalCount,dueAmount,pageAmount,totalAmount,getData,dataLoading} = UseGetDataSearch(`/invoices-outgoing/listing` , params);
    
    
      const defaultHeader = [
        // {
        //   title: "ID",
        //   width: "5%",
        //   field: "invoiceOutId",
        //   textAlign: "left",
        //   rowAlign: "left",
        // },
        {
          title: "Ref. ",
          width: "10.71%",
          isLink: true,
          id: "invoiceOutId",
          link: `/invoice/invoice-outgoing/view/`,
          field: "ref",
          textAlign: "left",
          rowAlign: "left",
        },
        // {
        //   title: "PR",
        //   width: "9%",
        //   isLink: true,
        //   id: "invoiceOutId",
        //   link: `/project/sales/invoice_outgoing/${officeId}/${projecTId}/view/`,
        //   field: "prRef",
        //   textAlign: "left",
        //   rowAlign: "left",
        // },
        // {
        //   title: "SO NO.",
        //   width: "9%",
        //   isLink: true,
        //   id: "invoiceOutId",
        //   link: `/project/sales/invoice_outgoing/${officeId}/${projecTId}/view/`,
        //   field: "coref",
        //   textAlign: "left",
        //   rowAlign: "left",
        // },
         GetNotUseRole("client") ? {
                        title: "Client",
                        width: "15%",
                        field: "clientName",
                        isLink: true,
                        id: "invoiceOutId",
                        link: `/invoice/invoice-outgoing/view/`,
                        textAlign: "left",
                        rowAlign: "left",
                      }:
                      {
                        title: " ",
                        width: "0.1%",
                        field: " ",
                        textAlign: "left",
                        rowAlign: "left",
                      },
        {
          title: "Date",
          width: "10.71%",
          field: "date",
          type:"date",
          textAlign: "left",
          rowAlign: "left",
        },
        {
          title: "Total Amt.",
          width: "10.71%",
          field: "totalAmount",
          type:"amount",
          textAlign: "left",
          rowAlign: "left",
        },
        {
          title: "Paymt. DueDate",
          width: "10.71%",
          field: "paymentDueDate",
          type:"date",
          textAlign: "left",
          rowAlign: "left",
        },
        {
          title: "Days Elapsed",
          width: "10.71%",
          field: "daysElapsed",
          // type:"date",
          textAlign: "left",
          rowAlign: "left",
        },
        {
          title: "Mode Of Paymt.",
          width: "10.71%",
          field: "modeOfPayment",
          // type:"amount",
          textAlign: "left",
          rowAlign: "left",
        },
        {
          title: "Status",
          width: "10.71%",
          field: "status",
          // type:"amount",
          textAlign: "left",
          rowAlign: "left",
        },
    
        {
          title: "Action",
          width: "10%",
          field: "action",
          textAlign: "center",
          rowAlign: "center",
          contents: {
            // fetcher: getData,
            id: "invoiceOutId",
            removeValue: "ref",
            url: '/invoices-outgoing/',
            moduleName: "Invoice-Outgoing",
            from: `/invoice/invoice-outgoing`,
            editLink: `/invoice/invoice-outgoing/edit/`,
            viewLink: `/invoice/invoice-outgoing/view/`,
          },
        },
      ];
    
      let availableHeaders = [
       
      ];
    
 const [exportValue, setExportValue] = useState({
   Client:"",
   Project:"",
   salesPerson:"",
   Location:"",
   Inspector:"",
   InspectionDate:"",
   Status:"",
 });
 const ExportFormik = useFormik({
   enableReinitialize: true,
   initialValues: exportValue,
   validateOnChange: false,
   validateOnBlur: false,
   onSubmit: async (value, { resetForm }) => {
     try {
       const response = await axiosInstance.get(
         `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
         {
           responseType: "blob",
         }
       );

       const pdfBlob = new Blob([response.data], {
         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
       });

       const link = document.createElement("a");
       link.href = window.URL.createObjectURL(pdfBlob);
       link.download = `CQ Report ${NuDate({
         value: new Date(),
         format: "DD-MMM-YYYY",
       })}.xlsx`;

       document.body.appendChild(link);
       link.click();

       link.parentNode.removeChild(link);
     } catch (error) {
       console.error("Error downloading the PDF:", error);
     }
   },
 });
 const closeFilterDialogebox = () => {
   setShowExport(false);
 };
      useEffect(() => {
        setParams({...params,page:page,per_page:pageCount})
  
      }, [page, pageCount]);
  
      const closeFilterDialog = () => {
        setShowFilterDialog(false);
      };
  
      const [showImportModal, setShowImportModal] = useState(false);
  
      const handleImportClick = () => {
        setShowImportModal(true);
      };
    
      const closeModal = () => {
        setShowImportModal(false);
      };
      
      
      const [showEdit, setShowEdit] = useState(false)
      const [showDelete, setShowDelete] = useState(false)
      const [listofNumbers, setListofNumbers] = useState([])
      const [fullList, setFullList] = useState([])
    
      const selectOneFunction = (value) =>{ 
        let NewId;
        if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
          NewId = listofNumbers.filter(Temp=> Temp !== value);
          setListofNumbers(NewId)
        }else{
          setListofNumbers([...listofNumbers,value])
        }
      }
    
      const selectMultipleFunction = (e) =>{ 
    console.log(e.target.checked);
    if(e.target.checked){
      setListofNumbers(fullList)
    }else{
      setListofNumbers([])
    }
    
      }
    
      useEffect(()=>{
        let tempArr = []
        data && data.forEach(i=>{
          console.log("I",i?.invoiceOutId);
          tempArr.push(i?.invoiceOutId)
        });
        setFullList(tempArr)
      },[data])
         
      const [valueOfSearch,setValuesofSearch] = useState("")
      function searchFunction(e) {
    
        
        setValuesofSearch(e?.target?.value)
        setParams({ ...params, search: e?.target?.value, page:1 });
        setPage(1)
      }
    
      return (
        <>
        <InvoiceLayout
        //  setOpen={closeModal}
        searchFun={searchFunction}
        searchValue={valueOfSearch}
         getData={getData}
         isFilter={filter}
         setFilterOpen={setShowFilterDialog}
         ClearFilter={clearFilter}
         CreateAccess={GetAccess("invoice_out_create")}
          //  ImportAccess={GetAccess("invoice_out_import")}
          //           ExportAccess={GetAccess("invoice_out_export")}
                    // setOpenExport={setShowExport}
        //  ImportAccess={GetAccess("customer_quote_create")}
         officeId={officeId}
               total={totalCount}
               total_amount={totalAmount}
               page_amount={pageAmount}
               due_amount={dueAmount}


         // projecTId={projecTId}
           >
  
  {
    screenSize.width <= "786" ?(<>
    <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
    <MobileOutgoingIndex
    data={data}
    total={totalCount}
               total_amount={totalAmount}
               page_amount={pageAmount}
               due_amount={dueAmount}

    pageIndex={page}
    setPageIndex={setPage}
    dataCount={pageCount}
    setDataCount={setPageCount}
    getData={getData}


    />
    </div>
    </>):(<>
        <div className='w-full h-full '>
        {/* <div className='w-full flex justify-between items-center'>
   
        <Breadcrumb
            items={[
              {
                  name:"Invoices-Outgoing"
              }
            ]}
        />
  
  
  
        <div className=' flex gap-2'>
        <SearchBar
                handleChange={(e) =>{
                  setParams({ ...params, search: e.target.value, page:1 });
                  setPage(1)
                }}
                value={params.search||searchQuery}
              />    <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
            {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
          
         {/* <CreateButton label='Import'  handleClick={handleImportClick} /> */}
         {/* {GetAccess("invoice_out_create") &&  <Link to={`/main/${officeId}/sales/invoice_outgoing/create/`}><CreateButton label='Outgoing'/></Link> }
        </div>
        </div>  */}
    
        <CustomDataTable
          fetcher={getData}
          data={data}
          availableHeaders={availableHeaders}
          defaultHeader={defaultHeader}
          bodyHeight="max-h-[calc(100vh-260px)]"
          height="h-[calc(100vh-160px)]"
          total={totalCount}
               total_amount={totalAmount}
               page_amount={pageAmount}

               due_amount={dueAmount}

          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
          title="Invoice-Outgoing"
          storageName="Invoice-OutgoingTable"
          selectOneFunction={selectOneFunction}
          setShowDelete={setShowDelete}
          showDelete={showDelete}
          setShowEdit={setShowEdit}
          showEdit={showEdit}
          listofNumbers={listofNumbers}
          hasMultiEdit={true}
          selectMultipleFunction={selectMultipleFunction}
          fullList={fullList}
           getById="invoiceOutId"
           editAccess="invoice_out_edit"      
           deteleAccess="invoice_out_delete" 
           dataLoading={dataLoading}
           searchQuery={params?.search!=""?params?.search:""}
  
        />
        </div>
        </>) 
        }
        </InvoiceLayout>
          {showFilterDialog && (
               
               
               <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                 <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                   <h2 className="text-xl mb-4">Filter Outgoing</h2>
                   <form onSubmit={formik.handleSubmit}> 
                      <div className="flex flex-col mb-4">
                      {/* <p className="py-2 px-6 text-m"> Date</p>
                      <div className="md:flex  justify-between  w-full ">
                      <NuDate
                  label="From"
                  placeholder="DD/MM/YYYY"
                  formik={formik}
                  name="fromDate"
                  width="w-full "
                />
                  <NuDate
                  label="To"
                  placeholder="DD/MM/YYYY"
                  formik={formik}
                  name="toDate"
                  width="w-full "
                />
                </div> */}
                <p className="py-2 px-6 text-m">Due Date</p>
                      <div className="md:flex justify-between  w-full ">
                  <NuDate
                  label="From"
                  placeholder="DD/MM/YYYY"
                  formik={formik}
                  name="fromDueDate"
                  width="w-full "
                />
                  <NuDate
                  label="To"
                  placeholder="DD/MM/YYYY"
                  formik={formik}
                  name="toDueDate"
                  width="w-full "
                />
  </div>
                      <FormikSelectTwo
                label="Mode Of Payment"
                placeholder="Choose"
                formik={formik}
                Options={ModeOfPayment}
                name="modeOfPayment"
                width="w-full "
              />
  
              {/* <FormikSelectTwo
                type="text"
                label="Division"
                placeholder="Choose"
                Options={Division}
                formik={formik}
                name="division"
                width="w-full "
              /> */}
               <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={Status}
                  formik={formik}
                  name="status"
                  width="w-full "
                />
                      </div>
                     <div className="flex justify-end gap-2">
                       <CancelButton handleClick={closeFilterDialog} />
                       <SubmitButton name='Apply' />
                     </div>
                    </form> 
                 </div>
               </div>
             )}
            {showEdit && (
        <MultiEditOutgoing
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportOutgoing
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                     <p className="py-2 px-6 text-m"> Date</p>
                      <div className="flex  justify-between  w-full ">
                      <NuDate
                  label="From"
                  placeholder="DD/MM/YYYY"
                  formik={ExportFormik}
                  name="fromDate"
                  width="w-full "
                />
                  <NuDate
                  label="To"
                  placeholder="DD/MM/YYYY"
                  formik={ExportFormik}
                  name="toDate"
                  width="w-full "
                />
                </div>
                <p className="py-2 px-6 text-m">Due Date</p>
                      <div className="flex justify-between  w-full ">
                  <NuDate
                  label="From"
                  placeholder="DD/MM/YYYY"
                  formik={ExportFormik}
                  name="fromDueDate"
                  width="w-full "
                />
                  <NuDate
                  label="To"
                  placeholder="DD/MM/YYYY"
                  formik={ExportFormik}
                  name="toDueDate"
                  width="w-full "
                />
  </div>
                      <FormikSelectTwo
                label="Mode Of Payment"
                placeholder="Choose"
                formik={ExportFormik}
                Options={ModeOfPayment}
                name="modeOfPayment"
                width="w-full "
              />
  
              <FormikSelectTwo
                type="text"
                label="Division"
                placeholder="Choose"
                Options={Division}
                formik={ExportFormik}
                name="division"
                width="w-full "
              />
               <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={Status}
                  formik={ExportFormik}
                  name="status"
                  width="w-full "
                />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      </>
      )
}

export default InvoiceOutgoingIndex
